export default "__VITE_ASSET__28b59d24__"